@file:OptIn(InternalResourceApi::class)

package mapquizwebsite.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mapquizwebsite.shared.generated.resources/"

@delegate:ResourceContentHash(928_520_736)
internal val Res.drawable.app_store_download: DrawableResource by lazy {
      DrawableResource("drawable:app_store_download", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_store_download.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-712_161_819)
internal val Res.drawable.google_play_download: DrawableResource by lazy {
      DrawableResource("drawable:google_play_download", setOf(
        ResourceItem(setOf(), "${MD}drawable/google_play_download.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_076_844_456)
internal val Res.drawable.ic_cash: DrawableResource by lazy {
      DrawableResource("drawable:ic_cash", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_851_447_327)
internal val Res.drawable.ic_daily_rewards: DrawableResource by lazy {
      DrawableResource("drawable:ic_daily_rewards", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_daily_rewards.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_100_107_970)
internal val Res.drawable.ic_gold: DrawableResource by lazy {
      DrawableResource("drawable:ic_gold", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_gold.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_119_638_121)
internal val Res.drawable.ic_home: DrawableResource by lazy {
      DrawableResource("drawable:ic_home", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_646_754_927)
internal val Res.drawable.ic_info: DrawableResource by lazy {
      DrawableResource("drawable:ic_info", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_info.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-382_915_738)
internal val Res.drawable.ic_menu: DrawableResource by lazy {
      DrawableResource("drawable:ic_menu", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_menu.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-116_540_699)
internal val Res.drawable.ic_news: DrawableResource by lazy {
      DrawableResource("drawable:ic_news", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_news.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(230_939_329)
internal val Res.drawable.ic_store: DrawableResource by lazy {
      DrawableResource("drawable:ic_store", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_store.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_367_385_370)
internal val Res.drawable.mapquiz_cover: DrawableResource by lazy {
      DrawableResource("drawable:mapquiz_cover", setOf(
        ResourceItem(setOf(), "${MD}drawable/mapquiz_cover.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-768_404_844)
internal val Res.drawable.mapquiz_cover_dark: DrawableResource by lazy {
      DrawableResource("drawable:mapquiz_cover_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/mapquiz_cover_dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_927_202_103)
internal val Res.drawable.mapquiz_logo: DrawableResource by lazy {
      DrawableResource("drawable:mapquiz_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/mapquiz_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_007_260_778)
internal val Res.drawable.play_online: DrawableResource by lazy {
      DrawableResource("drawable:play_online", setOf(
        ResourceItem(setOf(), "${MD}drawable/play_online.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_store_download", Res.drawable.app_store_download)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("google_play_download", Res.drawable.google_play_download)
  map.put("ic_cash", Res.drawable.ic_cash)
  map.put("ic_daily_rewards", Res.drawable.ic_daily_rewards)
  map.put("ic_gold", Res.drawable.ic_gold)
  map.put("ic_home", Res.drawable.ic_home)
  map.put("ic_info", Res.drawable.ic_info)
  map.put("ic_menu", Res.drawable.ic_menu)
  map.put("ic_news", Res.drawable.ic_news)
  map.put("ic_store", Res.drawable.ic_store)
  map.put("mapquiz_cover", Res.drawable.mapquiz_cover)
  map.put("mapquiz_cover_dark", Res.drawable.mapquiz_cover_dark)
  map.put("mapquiz_logo", Res.drawable.mapquiz_logo)
  map.put("play_online", Res.drawable.play_online)
}
